export function setFavicon(url) {
  if (url) {
    const link = document.querySelector("link[rel*='icon']");
    if (link) {
      link.href = url;
    }
  }
}
